import { formatMoney, extractSectionId, Popover } from "//www.mangrovediamonds.com/cdn/shop/t/6/assets/theme.js?v=112701401618831908181787379769";
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// Check if the current URL matches "/collections/engagement"
if (window.themeVariables.settings.ringPage.includes(window.location.pathname) && window.location.pathname !== '/') {
  // Retrieve the ring_filters value from localStorage
  const ringFilters = localStorage.getItem('ring_filters');

  // Check if ring_filters is present and has the desired shape value
  if (ringFilters) {
    const filters = JSON.parse(ringFilters);
    const shape = filters.shape;
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const existingParam = searchParams.get('filter.v.option.shape');

    if (!existingParam && shape) {
      searchParams.append('filter.v.option.shape', capitalizeFirstLetter(shape));
      searchParams.append("section_id", document.querySelector('[is="facets-form"]').getAttribute('section-id'));
      // window.location.href = url.href;
      document.dispatchEvent(new CustomEvent("facet:update", {
        bubbles: true,
        detail: {
          url: url
        }
      }));
    }
  }
}


var RingButtons = class extends HTMLElement {
  constructor() {
    super(...arguments);
    let builder = localStorage.getItem('builder')
    if (builder) {
      this.builder = JSON.parse(builder)
    }
  }

  connectedCallback() {
    this.choose_button = this.querySelector('[is="choose-ring"]')
    this.update_button = this.querySelector('[is="update-ring"]')
    this.change_button = this.querySelector('[is="change-ring"]')
    this.form = document.forms[this.getAttribute("form")]

    this.handleButtons()
    this.form?.addEventListener("variant:change", this.onVariantChanged.bind(this));
    this.form?.addEventListener("cart:error", this.onCartError.bind(this));

    this.choose_button.addEventListener("click", this.chooseRing.bind(this))
    this.update_button.addEventListener("click", this.chooseRing.bind(this))
    this.change_button.addEventListener("click", this.changeRing.bind(this))
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.onVariantChanged.bind(this));
    this.form?.removeEventListener("cart:error", this.onCartError.bind(this));
  }

  async chooseRing(e) {
    e.preventDefault();
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }
    e.target.setAttribute("disabled", "disabled");
    e.target.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const formData = new FormData(this.form);
    const formDataObject = {};
    for (let [key, value] of formData.entries()) {
      formDataObject[key] = value;
    }

    const response = await fetch(`${Shopify.routes.root}products/${this.dataset.handle}.js`);
    e.target.removeAttribute("disabled");
    e.target.removeAttribute("aria-busy");
    const responseJson = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    if (response.ok) {
      let builder = {}
      const builderData = localStorage.getItem('builder')
      if (builderData) {
        builder = JSON.parse(builderData)
      }

      const diamondFilters = localStorage.getItem('diamond_filters')
      let filters = {}
      if (diamondFilters) {
        filters = JSON.parse(diamondFilters)
      }

      const variant = responseJson.variants.find(v => v.id === parseInt(formDataObject.id))
      const shapeFromProduct = responseJson.options.find(s => s.name === "Shape")
      const shape = shapeFromProduct ? variant[`option${shapeFromProduct.position}`] : this.dataset.shape
      const numbers = this.dataset.carat?.split("-").map(parseFloat);

      const ring_filters = localStorage.getItem('ring_filters')
      if (ring_filters) {
        const ringFilter = JSON.parse(ring_filters)
        if (ringFilter.shape && !variant.options.includes(ringFilter.shape)) {
          this.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: `Sorry, You can't add this variant with that diamond. Please choose <b>${ringFilter.shape}</b> variant`
            }
          }));
          return;
        }
      }


      filters.shape = shape.split(",")
      if (numbers.length === 2) {
        filters.carats = [numbers[0], numbers[1]]
      }

      builder.ring = {
        product: responseJson,
        form: formDataObject,
        variant: variant,
      }

      localStorage.setItem('builder', JSON.stringify(builder))
      localStorage.setItem('diamond_filters', JSON.stringify(filters))
      sessionStorage.removeItem('current_filters')

      if (builder.diamond && builder.diamond.product) {
        return window.location.href = window.themeVariables.settings.completePage
      } else {
        return window.location.href = window.themeVariables.settings.diamondPage
      }
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
  }

  changeRing(e) {
    e.preventDefault();
    e.target.setAttribute("disabled", "disabled");
    e.target.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    let builder = {}
    const builderData = localStorage.getItem('builder')
    if (builderData) {
      builder = JSON.parse(builderData)
    }
    const diamondFilters = localStorage.getItem('diamond_filters')
    let filters = {}
    if (diamondFilters) {
      filters = JSON.parse(diamondFilters)
    }
    delete filters.shape;
    delete builder.diamond;
    localStorage.setItem('builder', JSON.stringify(builder))
    localStorage.setItem('diamond_filters', JSON.stringify(filters))
    e.target.removeAttribute("disabled");
    e.target.removeAttribute("aria-busy");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    return window.location.href = window.themeVariables.settings.ringPage
  }

  handleButtons() {
    if (this.builder && this.builder.ring) {
      this.choose_button.remove()
    } else {
      this.update_button.remove()
      this.change_button.remove()
    }
  }

  onVariantChanged(event) {
    if (this.builder && this.builder.ring) {
      this.update_button.disabled = !event.detail.variant || !event.detail.variant["available"];
      this.change_button.disabled = !event.detail.variant || !event.detail.variant["available"];
      if (!event.detail.variant) {
        this.update_button.innerHTML = window.themeVariables.strings.unavailableButton;
        this.change_button.innerHTML = window.themeVariables.strings.unavailableButton;
      } else {
        this.update_button.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.updateRingButton : window.themeVariables.strings.soldOutButton;
        this.change_button.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.chooseDifferentButton : window.themeVariables.strings.soldOutButton;
      }
    } else {
      this.choose_button.disabled = !event.detail.variant || !event.detail.variant["available"];
      if (!event.detail.variant) {
        this.choose_button.innerHTML = window.themeVariables.strings.unavailableButton;
      } else {
        this.choose_button.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.chooseRingButton : window.themeVariables.strings.soldOutButton;
      }
    }
  }

  onCartError(event) {
    const bannerElement = document.createRange().createContextualFragment(`
        <div class="banner banner--error" role="alert">
          ${event.detail.error}
        </div>
      `).firstElementChild;
    this.prepend(bannerElement);
    setTimeout(() => {
      bannerElement.remove();
    }, 2500);
  };
}

if (!window.customElements.get("ring-buttons")) {
  window.customElements.define("ring-buttons", RingButtons);
}

var DiamondButtons = class extends HTMLElement {
  constructor() {
    super(...arguments);
    let builder = localStorage.getItem('builder')
    if (builder) {
      this.builder = JSON.parse(builder)
    }
  }

  connectedCallback() {
    this.choose_button = this.querySelector('[is="choose-ring-button"]')
    this.another_button = this.querySelector('[is="choose-another-button"]')
    this.form = document.forms[this.getAttribute("form")]

    this.handleButtons()
    this.form?.addEventListener("variant:change", this.onVariantChanged.bind(this));
    this.form?.addEventListener("cart:error", this.onCartError.bind(this));

    this.choose_button.addEventListener("click", this.chooseDiamond.bind(this))
    this.another_button.addEventListener("click", this.changeDiamond.bind(this))
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.onVariantChanged.bind(this));
    this.form?.removeEventListener("cart:error", this.onCartError.bind(this));
  }

  async chooseDiamond(e) {
    e.preventDefault();
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    e.target.setAttribute("disabled", "disabled");
    e.target.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const formData = new FormData(this.form);
    const formDataObject = {};
    for (let [key, value] of formData.entries()) {
      formDataObject[key] = value;
    }

    const response = await fetch(`${Shopify.routes.root}products/${this.dataset.handle}.js`);
    e.target.removeAttribute("disabled");
    e.target.removeAttribute("aria-busy");
    const responseJson = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    if (response.ok) {
      let builder = {}
      const builderData = localStorage.getItem('builder')
      if (builderData) {
        builder = JSON.parse(builderData)
      }

      const diamondFilters = localStorage.getItem('ring_filters')
      let filters = {}
      if (diamondFilters) {
        filters = JSON.parse(diamondFilters)
      }

      const hasFilter = localStorage.getItem('diamond_filters')
      let currentFilter = {}
      if (hasFilter) {
        currentFilter = JSON.parse(hasFilter)
      }

      const variant = responseJson.variants.find(v => v.id === parseInt(formDataObject.id))
      const shapeFromProduct = responseJson.options.find(s => s.name === "Shape")
      const shape = shapeFromProduct ? variant[`option${shapeFromProduct.position}`] : this.dataset.shape
      const numbers = this.dataset.carat?.split("-").map(parseFloat);

      if (currentFilter.shape) {
        if (currentFilter.shape[0].toLowerCase() !== shape.toLowerCase()) {
          this.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: `Sorry, the <b>${shape}</b> diamond is not compatible with the selected <b>${currentFilter.shape[0]}</b> ring.`
            }
          }));
          return;
        }

        if (this.dataset.carat && currentFilter.carats.length == 2 && (this.dataset.carat < currentFilter.carats[0] || this.dataset.carat > currentFilter.carats[1])) {
          this.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: `Sorry, You need to select diamond within <b>${currentFilter.carats[0]}</b> to <b>${currentFilter.carats[1]} carat range.</b>`
            }
          }));
          return;
        }
      }

      filters.shape = capitalizeFirstLetter(shape)

      builder.diamond = {
        product: responseJson,
        form: formDataObject,
        variant: variant,
        others: {
          carat: this.dataset.carat,
          cut: this.dataset.cut,
          clarity: this.dataset.clarity,
          color: this.dataset.color,
        }
      }

      if (!variant.available) {
        return this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: `The product '${responseJson.title}' is not available.`
          }
        }));
      }

      localStorage.setItem('builder', JSON.stringify(builder))
      localStorage.setItem('ring_filters', JSON.stringify(filters))

      if (builder.ring && builder.ring.product) {
        return window.location.href = window.themeVariables.settings.completePage
      } else {
        return window.location.href = window.themeVariables.settings.ringPage
      }
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
  }

  changeDiamond(e) {
    e.preventDefault();
    e.target.setAttribute("disabled", "disabled");
    e.target.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    let builder = {}
    const builderData = localStorage.getItem('builder')
    if (builderData) {
      builder = JSON.parse(builderData)
    }
    builder.diamond = null
    localStorage.setItem('builder', JSON.stringify(builder))
    e.target.removeAttribute("disabled");
    e.target.removeAttribute("aria-busy");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    return window.location.href = `${Shopify.routes.root}collections/diamonds`;
  }

  handleButtons() {
    if (!this.builder || !this.builder?.diamond) {
      this.another_button.remove()
    }
  }

  onVariantChanged(event) {
    if (this.builder && this.builder.diamond) {
      this.another_button.disabled = !event.detail.variant || !event.detail.variant["available"];
      if (!event.detail.variant) {
        this.another_button.innerHTML = window.themeVariables.strings.unavailableButton;
      } else {
        this.another_button.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.chooseAnothreDiamond : window.themeVariables.strings.soldOutButton;
      }
    }

    this.choose_button.disabled = !event.detail.variant || !event.detail.variant["available"];
    if (!event.detail.variant) {
      this.choose_button.innerHTML = window.themeVariables.strings.unavailableButton;
    } else {
      this.choose_button.innerHTML = event.detail.variant["available"] ? this.getAttribute("template").includes("pre-order") ? window.themeVariables.strings.preOrderButton : window.themeVariables.strings.addToRingButton : window.themeVariables.strings.soldOutButton;
    }
  }

  onCartError(event) {
    const bannerElement = document.createRange().createContextualFragment(`
        <div class="banner banner--error" role="alert">
          ${event.detail.error}
        </div>
      `).firstElementChild;
    this.prepend(bannerElement);
    setTimeout(() => {
      bannerElement.remove();
    }, 2500);
  };
}

if (!window.customElements.get("diamond-buttons")) {
  window.customElements.define("diamond-buttons", DiamondButtons);
}

var DiamondRing = class extends HTMLElement {
  constructor() {
    super(...arguments);
    let builder = localStorage.getItem('builder')
    if (builder) {
      this.builder = JSON.parse(builder)
    }
  }

  connectedCallback() {
    this.button = this.querySelector('button')
    this.button.addEventListener("click", this.addToCart.bind(this))
  }

  async addToCart() {
    this.button.setAttribute("disabled", "disabled");
    this.button.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    let formData = {
      items: [
        {
          id: parseInt(this.builder.ring.form.id),
          quantity: parseInt(this.builder.ring.form.quantity),
        },
        {
          id: parseInt(this.builder.diamond.form.id),
          quantity: parseInt(this.builder.diamond.form.quantity),
        }
      ]
    };

    console.log(this.builder.ring.form.properties);

    if (this.builder.ring.form.hasOwnProperty('properties')) {
      const properties = this.builder.ring.form.properties;
      const propertiesKeys = Object.keys(properties);

      if (propertiesKeys.length > 0) {
        formData.items[0].properties = {};

        propertiesKeys.forEach(key => {
          formData.items[0].properties[key] = properties[key];
        });
      }
    }


    const ringFormKeys = Object.keys(this.builder.ring.form);
    const hasRingProperties = ringFormKeys.some(key => key.startsWith('properties['));

    if (hasRingProperties) {
      formData.items[0].properties = {};

      ringFormKeys.forEach(key => {
        if (key.startsWith('properties[')) {
          const propertyKey = key.substring(key.indexOf('[') + 1, key.indexOf(']'));
          formData.items[0].properties[propertyKey] = this.builder.ring.form[key];
        }
      });
    }

    const diamondFormKeys = Object.keys(this.builder.diamond.form);
    const hasProperties = diamondFormKeys.some(key => key.startsWith('properties['));

    if (hasProperties) {
      formData.items[1].properties = {};

      diamondFormKeys.forEach(key => {
        if (key.startsWith('properties[')) {
          const propertyKey = key.substring(key.indexOf('[') + 1, key.indexOf(']'));
          formData.items[1].properties[propertyKey] = this.builder.diamond.form[key];
        }
      });
    }

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(formData),
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        'Content-Type': 'application/json'
      }
    });
    this.button.removeAttribute("disabled");
    this.button.removeAttribute("aria-busy");
    const responseJson = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    if (response.ok) {
      localStorage.removeItem('builder')
      localStorage.removeItem('ring_filters')
      localStorage.removeItem('diamond_filters')
      return window.location.href = `${Shopify.routes.root}cart`;
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
  }
}

if (!window.customElements.get("diamond-ring")) {
  window.customElements.define("diamond-ring", DiamondRing);
}

var BuilderWidget = class extends HTMLElement {
  constructor() {
    super(...arguments);
    let builder = localStorage.getItem('builder')
    if (builder) {
      this.builder = JSON.parse(builder)
    }
    this.url = window.location.pathname
    this.tags = this.dataset.tags?.split(',') || []
  }
  connectedCallback() {
    this.ringContainer = this.querySelector('#first')
    this.diamondContainer = this.querySelector('#second')
    this.completeContainer = this.querySelector('#complete')

    if (this.url.includes('collections') && (window.themeVariables.settings.ringPage.includes(window.location.pathname) || window.themeVariables.settings.diamondPage.includes(window.location.pathname)) || this.url.includes('pages/engagement-bridal') || (this.url.includes('products') && (this.tags.includes('Builder_Ring') || this.tags.includes('Builder_Diamond')))) {
      this.show()
    }

    this.querySelector('.button-clear').addEventListener('click', () => {
      localStorage.removeItem('builder')
      localStorage.removeItem('ring_filters')
      localStorage.removeItem('diamond_filters')
      window.location.reload()
    })

    this.ringContainer.querySelectorAll('.choose-product').forEach(button => button.addEventListener('click', (e) => {
      e.preventDefault()
      localStorage.setItem('widget_data', 'ring')
      window.location.href = window.themeVariables.settings.ringPage
    }));

    this.diamondContainer.querySelectorAll('.choose-product').forEach(button => button.addEventListener('click', (e) => {
      e.preventDefault()
      localStorage.setItem('widget_data', 'diamond')
      window.location.href = window.themeVariables.settings.diamondPage
    }));

    this.querySelectorAll('.mobile_view').forEach(button => button.addEventListener('click', (e) => {
      e.preventDefault()
      if (document.querySelector(`#${button.dataset.id}`).style.display === 'block') {
        document.querySelector(`#${button.dataset.id}`).style.display = 'none';
      } else {
        document.querySelector(`#${button.dataset.id}`).style.display = 'block'
      }
    }));

    this.handleActive()

    if (!this.builder) return;

    if (this.builder.ring && this.builder.ring.product) {
      this.renderRing()
    }

    if (this.builder.diamond && this.builder.diamond.product) {
      this.renderDiamond()
    }

    if (this.builder.ring && this.builder.ring.product && this.builder.diamond && this.builder.diamond.product) {
      this.renderComplete()
    }
  }

  renderRing() {
    const product = this.builder.ring.product
    this.ringContainer.querySelectorAll('.product-name').forEach(element => element.innerHTML = product.title);
    this.ringContainer.querySelectorAll('.step-price').forEach(element => element.innerHTML = formatMoney(product.price, currencyFormat));
    if (product.featured_image) {
      this.ringContainer.querySelectorAll('.product-image').forEach(element => element.setAttribute('src', product.featured_image));
    }
    this.ringContainer.querySelectorAll('.view-product').forEach(element => element.setAttribute('href', product.url + '?variant=' + this.builder.ring.variant.id));
    this.ringContainer.classList.add('active-step')

    this.ringContainer.querySelectorAll('.remove-product').forEach(button => button.addEventListener('click', () => {
      let newBuilder = this.builder
      newBuilder.ring = null
      localStorage.setItem('builder', JSON.stringify(newBuilder))
      localStorage.removeItem('diamond_filters')
      window.location.href = window.themeVariables.settings.ringPage
    }));
  }

  renderDiamond() {
    const product = this.builder.diamond.product
    this.diamondContainer.querySelectorAll('.product-name').forEach(element => element.innerHTML = product.title);
    this.diamondContainer.querySelectorAll('.step-price').forEach(element => element.innerHTML = formatMoney(product.price, currencyFormat));
    if (product.featured_image) {
      this.diamondContainer.querySelectorAll('.product-image').forEach(element => element.setAttribute('src', product.featured_image));
    }
    this.diamondContainer.querySelectorAll('.view-product').forEach(element => element.setAttribute('href', product.url + '?variant=' + this.builder.diamond.variant.id));
    this.diamondContainer.classList.add('active-step')

    this.diamondContainer.querySelectorAll('.remove-product').forEach(button => button.addEventListener('click', () => {
      let newBuilder = this.builder
      newBuilder.diamond = null
      localStorage.setItem('builder', JSON.stringify(newBuilder))
      localStorage.removeItem('ring_filters')
      window.location.href = window.themeVariables.settings.diamondPage
    }));
  }

  renderComplete() {
    const container = this.querySelector('#complete')
    container.classList.add('active-step')
    this.classList.add('complete-step')
  }

  handleActive() {
    const widget_data = localStorage.getItem('widget_data')
    if (this.builder && this.builder.ring && this.builder.ring.product && this.builder.diamond && this.builder.diamond.product) {
      this.diamondContainer.classList.remove('current')
      this.ringContainer.classList.remove('current')
      this.completeContainer.classList.add('current')
    } else if (widget_data === 'ring' || window.themeVariables.settings.ringPage.includes(window.location.pathname)) {
      this.ringContainer.classList.add('current')
      this.diamondContainer.classList.remove('current')
    } else if (widget_data === 'diamond' || window.themeVariables.settings.diamondPage.includes(window.location.pathname)) {
      this.diamondContainer.classList.add('current')
      this.ringContainer.classList.remove('current')
    }
  }

  show() {
    this.style.display = 'block';
  }

  hide() {
    this.style.display = 'none';
  }
}

if (!window.customElements.get("builder-widget")) {
  window.customElements.define("builder-widget", BuilderWidget);
}

var BuilderProduct = class extends HTMLElement {
  #isLoaded = false;
  constructor() {
    super(...arguments);
    if (Shopify.designMode) {
      this.#isLoaded = true;
    }

    let builder = localStorage.getItem('builder')
    if (builder) {
      this.builder = JSON.parse(builder)
    }
  }

  connectedCallback() {
    if (!this.builder || !this.builder.ring.product || !this.builder.diamond.product) {
      return window.location.href = window.Shopify.routes.root
    }

    if (!this.#isLoaded) {
      this.loading()
      this.loadProducts()
    }
  }

  async loadProducts() {
    if (!this.#isLoaded) {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      const ringContent = await (await fetch(`${window.Shopify.routes.root}products/${this.builder.ring.product.handle}?variant=${this.builder.ring.variant.id}`)).text();
      const diamondContent = await (await fetch(`${window.Shopify.routes.root}products/${this.builder.diamond.product.handle}`)).text();
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      const ringDoc = new DOMParser().parseFromString(ringContent, "text/html");
      const diamondDoc = new DOMParser().parseFromString(diamondContent, "text/html");

      // Ring
      const ringGalleryThumbs = ringDoc.querySelector("product-gallery-navigation");
      const ringGallery = ringDoc.querySelector(".product-gallery__carousel");
      const ringDescription = ringDoc.querySelector(".product-content-below-gallery__description");
      const ringSpec = ringDoc.getElementById("product_properties");
      const ringThumbnails = Array.from(ringGalleryThumbs.querySelectorAll('button:not([hidden])'));
      const ringMains = Array.from(ringGallery.querySelectorAll(".product-gallery__media:not([hidden])"));
      this.querySelector("product-gallery-navigation").replaceChildren(...ringThumbnails.map(thumbnail => document.importNode(thumbnail, true)));
      this.querySelector(".product-gallery__carousel").replaceChildren(...ringMains.map(thumbnail => document.importNode(thumbnail, true)));
      this.querySelector("#setting-details__content").replaceChildren(document.importNode(ringSpec, true));
      this.querySelector(".product-content-below-gallery__description").replaceChildren(document.importNode(ringDescription, true));

      // Diamond
      const diamondGalleryThumbs = diamondDoc.querySelector("product-gallery-navigation");
      const diamondGallery = diamondDoc.querySelector(".product-gallery__carousel");
      const diamondSpec = diamondDoc.getElementById("product_properties");
      const diamondThumbnails = Array.from(diamondGalleryThumbs.querySelectorAll('button:not([hidden])'));
      const diamondMains = Array.from(diamondGallery.querySelectorAll(".product-gallery__media:not([hidden])"));
      diamondThumbnails.forEach(thumbnail => {
        thumbnail.setAttribute('aria-current', 'false');
        const importedNode = document.importNode(thumbnail, true);
        this.querySelector("product-gallery-navigation").appendChild(importedNode);
      });
      diamondMains.forEach(thumbnail => {
        thumbnail.classList.remove("is-initial");
        const importedNode = document.importNode(thumbnail, true);
        this.querySelector(".product-gallery__carousel").appendChild(importedNode);
      });
      this.querySelector("#diamond-details__content").replaceChildren(document.importNode(diamondSpec, true));

      this.querySelector("product-gallery-navigation").connectedCallback();

      this.querySelector('.product-title').innerHTML = `${this.builder.ring.product.title} + ${this.builder.diamond.product.title}`
      document.title = `${this.builder.ring.product.title} + ${this.builder.diamond.product.title}`;
      this.querySelector('sale-price').innerHTML = formatMoney(this.builder.ring.variant.price + this.builder.diamond.variant.price, currencyFormat)
      this.querySelector('[data-block-type="variant-picker"]').innerHTML = `
        <div class="grouped-info-wrapper">
            <div class="product" data-product-key="first">
                <div class="icon-ring"></div>
                <div class="product-name">${this.builder.ring.product.title}</div>
                <div class="product-options ring-options">${this.builder.ring.variant.option1}</div>
                <div class="price">${formatMoney(this.builder.ring.variant.price, currencyFormat)}</div>
                <a href="${this.builder.ring.product.url}?variant=${this.builder.ring.variant.id}" class="action link">Change</a>
            </div>
            <div class="icon-plus"></div>
            <div class="product" data-product-key="second">
                <div class="icon-diamond"></div>
                <div class="product-name">${this.builder.diamond.product.title}</div>
                <div class="product-options">
                  <span> ${this.builder.diamond.others.carat} Carat - ${this.builder.diamond.others.cut} Cut - ${this.builder.diamond.others.clarity} Clarity - ${this.builder.diamond.others.color} Color </span>
                </div>
                <div class="price">${formatMoney(this.builder.diamond.variant.price, currencyFormat)}</div>
                <a href="${this.builder.diamond.product.url}?variant=${this.builder.diamond.variant.id}" class="action link">Change</a>
            </div>
        </div>
      `

      this.#isLoaded = true;
      this.removeLoading();
    }
  }

  loading() {
    const loader = document.createElement('div')
    loader.classList.add("lds-spinner")
    loader.innerHTML = '<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>'
    this.appendChild(loader)
    this.classList.add('loading')
  }

  removeLoading() {
    if (this.querySelector('.lds-spinner')) {
      this.querySelector('.lds-spinner').remove()
    }
    this.classList.remove('loading')
  }
}

if (!window.customElements.get("builder-product")) {
  window.customElements.define("builder-product", BuilderProduct);
}

var WishlistProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.isLoaded = false;
  }
  connectedCallback() {
    this.loadProducts();
  }

  searchQueryString() {
    let items = JSON.parse(localStorage.getItem("theme:wishlist-products") || "[]");
    if (window.themeVariables.settings.wishlist && window.themeVariables.settings.wishlist.length) {
      items = [...items, ...window.themeVariables.settings.wishlist]
    }
    items = new Set(items);

    if (this.hasAttribute("exclude-id")) {
      items.delete(parseInt(this.getAttribute("exclude-id")));
    }
    return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
  }

  async loadProducts() {
    if (this.isLoaded) {
      return;
    }
    this.isLoaded = true;
    const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${this.searchQueryString()}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("wishlist-products");
    if (recentlyViewedProductsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
    } else {
      section.remove();
    }

    this.querySelectorAll('wishlist-button').forEach(elm => {
      elm.addEventListener("wishlist:reload", () => {
        this.isLoaded = false;
        this.loadProducts()
      });
    });
  }
};

if (!window.customElements.get("wishlist-products")) {
  window.customElements.define("wishlist-products", WishlistProducts);
}

var WishlistButton = class extends HTMLElement {
  constructor() {
    super();
    let products = JSON.parse(localStorage.getItem('theme:wishlist-products') || '[]')
    if (window.themeVariables.settings.wishlist) {
      products = [...products, ...window.themeVariables.settings.wishlist]
    }

    this.products = new Set(products);
    this.productId = parseInt(this.dataset.productId)
  }

  connectedCallback() {
    if (this.products.has(this.productId)) {
      this.classList.add('active')
    }

    this.addEventListener("click", async (event) => {
      const products = new Set(JSON.parse(localStorage.getItem('theme:wishlist-products') || '[]'));
      if (products.has(this.productId)) {
        products.delete(this.productId);
        this.classList.remove('active')
      } else {
        this.classList.add('active')
        products.add(this.productId);
      }

      localStorage.setItem('theme:wishlist-products', JSON.stringify(Array.from(products.values()).reverse()));
      this.dispatchEvent(new CustomEvent("wishlist:reload"));
      if (window.themeVariables.settings.customer) {
        await fetch('https://mangrove-api.quentin-3e1.workers.dev/api/wishlist', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({email: window.themeVariables.settings.customer, products: Array.from(products.values())}),
        })
      }
    });
  }
};
if (!window.customElements.get("wishlist-button")) {
  window.customElements.define("wishlist-button", WishlistButton);
}

var WishlistLink = class extends HTMLAnchorElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const items = new Set(JSON.parse(localStorage.getItem("theme:wishlist-products") || "[]"));
    if (items.size > 0) {
      this.classList.add('active');
    }
  }
};
if (!window.customElements.get("wishlist-link")) {
  window.customElements.define("wishlist-link", WishlistLink, { extends: "a" });
}

var FacetsPerpagePopover = class extends Popover {
  constructor() {
    super();
    this.addEventListener("listbox:change", this.onPerpageChange.bind(this));
  }

  onPerpageChange(event) {
    const diamond_table = document.querySelector('diamond-table')
    const url = new URL(diamond_table.dataset.url);
    url.searchParams.set("per_page", event.detail.value);
    url.searchParams.delete("page");

    this.dispatchEvent(new CustomEvent("diamond:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facets-perpage-popover")) {
  window.customElements.define("facets-perpage-popover", FacetsPerpagePopover);
}


var Consultation = class extends HTMLElement {
  constructor() {
    super();
    this.data = window.themeVariables.settings.consultations;
    this.type = this.dataset.type;
  }

  connectedCallback() {
    this.render();
  }

  render() {
    const filteredData = this.data.filter(item => item.type === this.type);
    const topics = [...new Set(filteredData.map(item => item.topic))];
    const locations = [...new Set(filteredData.map(item => item.location))];

    if (topics.some(topic => topic.trim() !== '')) {
      const container = document.createElement('div');
      container.className = 'form-control';

      const topicLabel = document.createElement('label');
      topicLabel.setAttribute('for', 'consultation-topic');
      topicLabel.className = 'floating-label text-xs';
      topicLabel.textContent = 'What Would You Like Consultation On?';

      const topicSelect = document.createElement('select');
      topicSelect.id = 'consultation-topic';
      topicSelect.name = 'topic';
      topicSelect.className = 'select';
      topics.forEach(topic => {
        const option = document.createElement('option');
        option.value = topic;
        option.textContent = topic;
        topicSelect.appendChild(option);
      });

      const topicSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      topicSvg.setAttribute('aria-hidden', 'true');
      topicSvg.setAttribute('focusable', 'false');
      topicSvg.setAttribute('fill', 'none');
      topicSvg.setAttribute('width', '10');
      topicSvg.setAttribute('viewBox', '0 0 10 6');

      const topicPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      topicPath.setAttribute('d', 'm1 1 4 4 4-4');
      topicPath.setAttribute('stroke', 'currentColor');
      topicPath.setAttribute('stroke-linecap', 'square');

      topicSvg.appendChild(topicPath);

      container.appendChild(topicSelect);
      container.appendChild(topicSvg);
      container.appendChild(topicLabel);

      this.appendChild(container);
    }

    if (locations.some(location => location.trim() !== '')) {
      const locationContainer = document.createElement('div');
      locationContainer.className = 'form-control';

      const locationLabel = document.createElement('label');
      locationLabel.setAttribute('for', 'consultation-location');
      locationLabel.className = 'floating-label text-xs';
      locationLabel.textContent = 'Select A Location';

      const locationSelect = document.createElement('select');
      locationSelect.id = 'consultation-location';
      locationSelect.name = 'location';
      locationSelect.className = 'select';
      locations.forEach(location => {
        if (location.trim() !== '') {
          const option = document.createElement('option');
          option.value = location;
          option.textContent = location;
          locationSelect.appendChild(option);
        }
      });

      const locationSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      locationSvg.setAttribute('aria-hidden', 'true');
      locationSvg.setAttribute('focusable', 'false');
      locationSvg.setAttribute('fill', 'none');
      locationSvg.setAttribute('width', '10');
      locationSvg.setAttribute('viewBox', '0 0 10 6');

      const locationPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      locationPath.setAttribute('d', 'm1 1 4 4 4-4');
      locationPath.setAttribute('stroke', 'currentColor');
      locationPath.setAttribute('stroke-linecap', 'square');

      locationSvg.appendChild(locationPath);

      locationContainer.appendChild(locationSelect);
      locationContainer.appendChild(locationSvg);
      locationContainer.appendChild(locationLabel);

      this.appendChild(locationContainer);
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button';
    button.textContent = 'Select Date';

    button.addEventListener('click', () => {
      const topicSelect = this.querySelector('#consultation-topic');
      const locationSelect = this.querySelector('#consultation-location');
      const selectedTopic = topicSelect?.value || '';
      const selectedLocation = locationSelect?.value || '';

      // Find the Calendly URL based on the selected topic and location
      const matchingConsultation = this.data.find(item =>
        item.topic === selectedTopic && item.location === selectedLocation
      );

      if (matchingConsultation && matchingConsultation.calendly) {
        const calendlyURL = matchingConsultation.calendly;
        Calendly.showPopupWidget(calendlyURL)
      } else {
        console.log('No matching consultation found');
      }
    });

    this.appendChild(button);
  }
};

if (!window.customElements.get('consultation-element')) {
  window.customElements.define('consultation-element', Consultation);
}
